import React from 'react';

import LandingPageJobTitles from '@pflegia/ui/shared/landing-page/landing-page-job-titles/LandingPageJobTitles';

import PflegiaHeadline from '../headline/Headline';
import { PRAXIA_CANDIDATE_TITLES, PRAXIA_EMPLOYER_TITLES } from './praxia-titles';

const PraxiaJobTitles: React.FC<{ isEmployer?: boolean }> = ({ isEmployer = false }) => {
  const praxiaTitles = isEmployer ? PRAXIA_EMPLOYER_TITLES : PRAXIA_CANDIDATE_TITLES;

  return (
    <LandingPageJobTitles
      jobTitles={praxiaTitles}
      headline={<PflegiaHeadline i18nKey={`landingPage:jobSearch.praxiaTitle${isEmployer ? 'Employer' : ''}`} />}
    />
  );
};

export default PraxiaJobTitles;
